const posts = [
  {
    id: 1,
    title: 'Responsible AI Best Practices',
    content: `\
### Start with the problem
Focus on your business goals before choosing technologies.

### Build multidisciplinary teams
Successful AI projects bring together domain experts, data scientists and engineers.

### Monitor and evaluate
Regularly review models for bias, drift and ethical concerns.
`,
  },
  {
    id: 2,
    title: 'Getting Data Ready for Machine Learning',
    content: `\
Clean, well-labeled data is the foundation of any ML initiative.

- Consolidate your data sources
- Address gaps in data quality
- Establish data governance early
`,
  },
  {
    id: 3,
    title: 'Case Study: Instant Real Estate Compliance',
    content: `\
A global law firm partnered with us to overhaul their real-estate planning due diligence. By fine-tuning an open-source large language model on past reports, we slashed the turnaround time from **7 days to under a minute**.

- Six custom condition types captured specialist knowledge
- Automated classification and summarisation pipeline
- Human reviewers validate results via a simple web interface

The new workflow cuts operational costs by **over 80%** while improving accuracy beyond manual review.
`,
  },
  {
    id: 4,
    title: 'Case Study: Digitising Well Logs for Faster Insights',
    content: `\
An international oil and gas operator needed a reliable way to digitise decades of scanned well logs. Our AI pipeline segments text, tables and graphs before tracing curves with spline fitting to meet WLDE standards.

- <5 minutes per log with a no-code upload portal
- Ready-to-use outputs for subsurface modelling
- Curve tracing errors reduced by more than 30%

The solution replaces days of manual effort and enables full-field digitisation at a fraction of the cost.
`,
  },
  {
    id: 5,
    title: 'Field-Proven AI Methodology',
    content: `\
Key themes across our projects:

- **Human-in-the-loop validation** keeps results reliable while improving training data.
- **Custom fine-tuning** adapts open models to niche terminology.
- **Edge detection and spline fitting** deliver precise signal extraction from complex graphs.
- **Lightweight UIs** encourage adoption by non-technical teams.
- **WLDE-compliant pipelines** integrate smoothly with geoscience workflows.

These practices ensure every engagement scales efficiently and delivers measurable ROI.
`,
  },
];

export default posts;
